<template>
  <!--投票弹框-->
  <div>
    <div class="samll-info-modal modal fade" id="infoModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-modal"></i>
              <p class="info-mess">{{aTitle}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--验证码-->
    <div class="modal-confim large-info-modal modal fade" id="modal-confim" role="dialog" aria-hidden="false"
         data-backdrop="static">
      <div class="modal-dialog" role="document" style="margin-top: 0">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="code" id="checkCode"><img style="width: 100%;height: 100%" :src="imgUrl" alt=""/></div>
              <p class="ModalConfimP" style="color: red;display: none">验证码错误</p>
              <input class="code-input" type="text" id="inputCode" value="" placeholder="请输入验证码">
              <button id="Button1" class="btn-1 buttonW buttonL" type="button">投票</button>
              <button id="cancel" class="btn-2 buttonW buttonR" data-dismiss="modal">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
      data (){
        return {
          aTitle: '成功',
          imgUrl: ''
        }
    },
    methods: {
        //操作按钮事件
    }
    ,
    mounted: function () {
        //操作DOM
      var id = this.$route.params.id;
      var that =this;
      var intervaLock;
      setTimeout(function () {
        // 投票按钮
        $('.show-box').on('click','.show-btn-poll', function () {
          $('#Button1').css('pointer-events', 'visible');
          var tha = this;
          //show-btn-poll-over
          if (!$(this).hasClass('show-btn-poll-over')) {
            var imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
            setTimeout(function(){
              that.imgUrl =imgUrl
            },200);
            that.$http.get(API.GetVoteConfig, {params: {activity_id: id}})
              .then(function (res) {
                //console.log(res)
                var data = res.data;
                //show-btn-poll-over  end_time  start_time  verify
                var cyrrend = new Date().getTime(),
                  end_time = new Date(data.end_time).getTime(),
                  start_time = new Date(data.start_time).getTime();
                //判断是否在投票时间内
                if (!cyrrend < end_time / 1  && !cyrrend > start_time) {
                  $(tha).addClass('show-btn-poll-over');

                  //不开启验证
                } else if (data.verify == 0) {
                  //直接投票
                  that.$http.get(API.GetIpLimit, {
                    params: {
                      activity_id: $(tha).attr('activity_id'),
                      item_id: $(tha).attr('data-id'),
                      code:''
                    }
                  }).then(function (res) {
                    //console.log(res)
                    if (res.code == 0) {
                      var voteNumber = $(tha).parent().children('.show-poll').children();
                      var n = voteNumber.html();
                      //console.log(n)
                      voteNumber.html(++n);
                      $(tha).find('em').addClass('em-animt');
                      that.aTitle = '投票成功';
                      $('#infoModal').modal('show');
                      intervaLock = setTimeout(function () {
                        $('#infoModal').modal('hide');
                        $(tha).find('em').removeClass('em-animt');
                      }, 2000);
                    } else {
                      that.aTitle = res.ext ? res.ext : res.msg;
                      $('#infoModal').modal('show');
                      $(tha).addClass('show-btn-poll-over');
                      intervaLock = setTimeout(function () {
                        $('#infoModal').modal('hide');
                      }, 2000);
                    }
                  })
                } else {  //开启验证
                  $('#modal-confim').modal('show');
                  //点击投票
                  $('#Button1').unbind('click').on('click', function () {
                    //验证
                    $('#Button1').css('pointer-events', 'none');
                    var n = $('#inputCode').val();
                    // var getValidvode = {
                    //   'code': n
                    // };
                     that.$http.get(API.GetIpLimit, {
                    params: {
                      activity_id: $(tha).attr('activity_id'),
                      item_id: $(tha).attr('data-id'),
                      code:n
                    }
                  }).then(function (res) {
                    //console.log(res)
                    if (res.code == 0) {
                      $('#modal-confim').modal('hide');
                      $('#inputCode').val('');
                      $('.ModalConfimP').hide();
                      var voteNumber = $(tha).parent().children('.show-poll').children();
                      var n = voteNumber.html();
                      //console.log(n)
                      voteNumber.html(++n);
                      $(tha).find('em').addClass('em-animt');
                      that.aTitle = '投票成功';
                      $('#infoModal').modal('show');
                      intervaLock = setTimeout(function () {
                        $('#infoModal').modal('hide');
                        $(tha).find('em').removeClass('em-animt');
                      }, 2000);
                    } else if(res.code == 1004){
                      that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
                      $('.ModalConfimP').show();
                      $('#Button1').css('pointer-events', 'visible');
                    }
                    else {
                      $('#modal-confim').modal('hide');
                      $('#inputCode').val('');
                      $('.ModalConfimP').hide();
                      that.aTitle = res.ext ? res.ext : res.msg;
                      $('#infoModal').modal('show');
                      $(tha).addClass('show-btn-poll-over');
                      intervaLock = setTimeout(function () {
                        $('#infoModal').modal('hide');
                      }, 2000);
                    }
                  })
                    // that.$http.get(API.GetValidvode, {params: getValidvode})
                    //   .then(function (res) {
                    //     if (res.code == 0) {
                    //       $('#modal-confim').modal('hide');
                    //       $('#inputCode').val('');
                    //       $('.ModalConfimP').hide();
                    //       //判断验证码是否正确
                    //       console.log($(tha).attr('data-id'), $(tha).attr('activity_id'))
                    //       that.$http.get(API.GetIpLimit, {
                    //         params: {
                    //           activity_id: $(tha).attr('activity_id'),
                    //           item_id: $(tha).attr('data-id'),
                    //           code:getValidvode
                    //         }
                    //       }).then(function (res) {
                    //         console.log(res)
                    //         if (res.code == 0) {
                    //           var voteNumber = $(tha).parent().children('.show-poll').children();
                    //           var n = voteNumber.html();
                    //           voteNumber.html(++n);
                    //           $(tha).find('em').addClass('em-animt');
                    //           that.aTitle = '投票成功';
                    //           $('#infoModal').modal('show');
                    //           intervaLock = setTimeout(function () {
                    //             $('#infoModal').modal('hide');
                    //             $(tha).find('em').removeClass('em-animt');
                    //           }, 2000);
                    //         } else {
                    //           $(tha).addClass('show-btn-poll-over');
                    //           that.aTitle = res.ext ? res.ext : res.msg;
                    //           $('#infoModal').modal('show');
                    //           intervaLock = setTimeout(function () {
                    //             $('#infoModal').modal('hide');
                    //           }, 2000);
                    //         }
                    //       })
                    //     } else {
                    //       that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
                    //       $('.ModalConfimP').show();
                    //       $('#Button1').css('pointer-events', 'visible');
                    //     }
                    //   })
                  });
                  //取消
                  $('#cancel').on('click', function () {
                    $('#modal-confim').modal('hide');
                    $('#inputCode').val('');
                    $('.ModalConfimP').hide();
                  });
                  //更换验证码
                  $('#checkCode').on('click', function () {
                    that.imgUrl = API.GetGetVCode + '?' + Math.random() * 10;
                  });
                }
              });
          }
        });
      }, 1800);
    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/template/voteAlert.vue